import { Component, OnInit, Input } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { environment } from '../../environments/environment';
import * as angular from 'angular';
import { resolve } from 'url';
import { UntypedFormBuilder } from '@angular/forms';
import { PayGateService } from '../services/paygate.service';
import { CarrierService } from 'app/services/carrier.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { accounting } from 'accounting';
import { PopupService } from 'app/services/shared/popup.service';
import { ToastrService } from 'ngx-toastr';
import { ConfirmDialogService } from 'app/services/shared/confirm-dialog/confirm-dialog.service';

declare var $: any;

@Component({
  selector: 'app-account-deposit',
  templateUrl: './accountDeposit.component.html',
  styleUrls: ['./accountDeposit.component.css'] 
  
})
export class AccountDepositComponent implements OnInit {
  @Input() dataCntrl: any;
  @Input() isApproval: boolean = false;
  
  isLoading = false;
  message = "Loading. Please wait...";
  instructMsg = '';
  departuresList: any = [];
  departuresListRemove: any = [];
  editFlag: boolean = false;
  pageload: boolean = false;
  showBlock: boolean = false;
  payGateUrl:string = "https://secure.paygate.co.za/payweb3/process.trans";
  payReqId: string = "";
  checkSum: string = "";
  carrierid : any;
  Carrier : any;
  amountDisplay : any;
  amount:number;
  paymentRef: string = "";


  checkoutForm = this.formBuilder.group({
    PAY_REQUEST_ID: '',
    CHECKSUM: ''
  });
  constructor(private formBuilder: UntypedFormBuilder, 
    private payGateService:PayGateService,
    private carrierService:CarrierService,
    private activeRoute: ActivatedRoute,
    private msgService: PopupService,
    private msg: ToastrService,private confirmDialogService: ConfirmDialogService,
    private router:Router) {}

  ngOnInit() {
    this.activeRoute.params.subscribe((params: Params) => {
    this.carrierid = params['id'];
    this.LoadCarrierAccountDetails();
    });

    
    
  }

  InitiatePayment()
  {
    if(!this.isFormValid())
    {
      return;
    }

    // this.msgService.showConfirm('Pay CrossEasy Carrier Account', `You will be redirected to PayGate`, 'Accepted payment methods include credit and debit cards, Secure EFT, Zapper and SnapScan','Proceed to Pay ' + this.amountDisplay,'Go Back').subscribe(isConfirmed => {
    //   if(isConfirmed){

    //     this.message = "Please wait while we redirect you to our payment service..."
    //     this.isLoading = true;
    //     this.payGateService.AddTransaction(this.Carrier.carrier_account_id, this.amount.toString()).subscribe(transactionRef=>{
      
    //     var REFERENCE = this.paymentRef =  this.Carrier.carrier_account_id.toString() + '_' + transactionRef;
    //     var AMOUNT= this.amount.toString();    
    //     var RETURN_URL= environment.payGateApi.returnUrl + REFERENCE;
    //     var EMAIL= this.Carrier.email;

    //   this.payGateService.InitiateTransaction(REFERENCE,AMOUNT,EMAIL,RETURN_URL).subscribe((res:any)=>{
        
    //     this.payReqId = res.PAY_REQUEST_ID;
    //       this.checkSum = res.CHECKSUM;
          
    //       if(this.payReqId != null && this.checkSum != null)
    //       {
    //         this.checkoutForm.patchValue({  
    //           PAY_REQUEST_ID:this.payReqId,         
    //           CHECKSUM:this.checkSum
    //         });

    //         let formSubmitBtn = document.getElementById("checkoutFormBtn");
    //         formSubmitBtn.click();

    //         this.isLoading = false;
    //         if(!environment.production)
    //         {
    //           this.router.navigateByUrl('carrier/paymentcomplete/'+this.carrierid);
    //         }
    //       }
    //       else
    //       {
    //         this.isLoading = false;
    //         this.msg.error('Payment Gateway Error', 'Something went wrong, please try again...');
    //       }
    //     }, (error)=>{

    //       this.isLoading = false;
    //       this.msg.error('Payment Gateway Error', 'Something went wrong, please try again...', error);
    //     });
    //   });

    //     }
    // });
    this.confirmDialogService.confirmThis('Pay CrossEasy Carrier Account. You will be redirected to PayGate. Accepted payment methods include credit and debit cards, Secure EFT, Zapper and SnapScan. Proceed to Pay '+ this.amountDisplay, () => {  

      this.message = "Please wait while we redirect you to our payment service..."
      this.isLoading = true;
      this.payGateService.AddTransaction(this.Carrier.carrier_account_id, this.amount.toString()).subscribe(transactionRef=>{
    
      var REFERENCE = this.paymentRef =  this.Carrier.carrier_account_id.toString() + '_' + transactionRef;
      var AMOUNT= this.amount.toString();    
      var RETURN_URL= environment.payGateApi.returnUrl + REFERENCE;
      var EMAIL= this.Carrier.email;

    this.payGateService.InitiateTransaction(REFERENCE,AMOUNT,EMAIL,RETURN_URL).subscribe((res:any)=>{
      
      this.payReqId = res.PAY_REQUEST_ID;
        this.checkSum = res.CHECKSUM;
        
        if(this.payReqId != null && this.checkSum != null)
        {
          this.checkoutForm.patchValue({  
            PAY_REQUEST_ID:this.payReqId,         
            CHECKSUM:this.checkSum
          });

          let formSubmitBtn = document.getElementById("checkoutFormBtn");
          formSubmitBtn.click();

          this.isLoading = false;
          if(!environment.production)
          {
            this.router.navigateByUrl('carrier/paymentcomplete/'+this.carrierid);
          }
        }
        else
        {
          this.isLoading = false;
          this.msg.error('Payment Gateway Error', 'Something went wrong, please try again...');
        }
      }, (error)=>{

        this.isLoading = false;
        this.msg.error('Payment Gateway Error', 'Something went wrong, please try again...', error);
      });
    });

  
    }, () =>  {  
      return;
    })
  }

  CreditAccounInSage()
  {
    this.carrierService.processAccountCredit({id:this.carrierid, refNum:this.paymentRef, amnt:this.amount/100})
  }

  isFormValid() : boolean
  {
    if(this.amount == null || this.amount == undefined || this.amount === 0)
    {
      this.msg.error('No Amount', 'Please enter an amount');
      return false;
    }
    else return true;
  }

  formatCurrency(value) {
    return accounting.formatMoney(value, 'R', 2, ' ', '.');
  }

  LoadCarrierAccountDetails()
  {
    this.carrierService.getById(this.carrierid).subscribe(carrier=>{
      this.Carrier = carrier;
      console.log(carrier);
    });
  }

  onSubmit(form: any, e: any): void {
    // Process checkout data here
    e.target.submit();
  }
  


  formatCurrency_TaxableValue(event)
  {      
    let inputAmount = Number.isNaN(Number(event.target.value))? 0 : Number(event.target.value);
    
    var uy = new Intl.NumberFormat('en-ZA',{style: 'currency', currency:'ZAR'}).format(inputAmount); 
    this.amount = inputAmount * 100;   
    if(inputAmount != 0)
    this.amountDisplay = uy;

    this.isFormValid();
  }
  
   isNumberKey(evt){
    var charCode = (evt.which) ? evt.which : evt.keyCode
    if (charCode > 31 && (charCode < 48 || charCode > 57))
        return false;
    return true;
}
   
  backToTab() {
    
  }
}
 